import React from 'react'
import styled from '@emotion/styled'
import { Switch, Redirect, Route } from 'react-router-dom'

import Navbar from './Navbar'
import Inboxes from './Inboxes'
import Organisations from './Organisations'

const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: row;
`
const Section = styled.div`
  height: 100%;
  width: 100%;
`

const Settings = () => (
  <Wrapper>
    <Navbar />

    <Section>
      <Switch>

        <Route
          path={`${process.env.CHAT_PUBLIC_PATH}/settings/inboxes`}
          component={Inboxes}
        />

        <Route
          path={`${process.env.CHAT_PUBLIC_PATH}/settings/organisations`}
          component={Organisations}
        />

        <Redirect
          to={`${process.env.CHAT_PUBLIC_PATH}/settings/inboxes`}
        />

      </Switch>
    </Section>
  </Wrapper>
)

export default Settings
